import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, Switch, FormControlLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#6d28d9", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#ede9fe", border: "1px solid #ddd6fe", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#4c1d95", lineHeight: 1.6 },
}));

const InfinityPayModal = ({ open, onClose, onSave }) => {
  const classes = useStyles();
  const [handle, setHandle] = useState("");
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/payment-settings").then(({ data }) => {
      const cfg = (data || []).find(s => s.provider === "infinitypay");
      if (cfg) { setHandle(cfg.token || ""); setActive(cfg.active !== false); }
      else { setHandle(""); setActive(true); }
    }).catch(() => {});
  }, [open]);

  const handleSave = async () => {
    if (!handle.trim()) { toast.error("Informe sua InfiniteTag."); return; }
    setLoading(true);
    try {
      await api.post("/payment-settings", { provider: "infinitypay", token: handle.trim(), active });
      toast.success("InfinityPay configurado com sucesso!");
      if (onSave) onSave();
      onClose();
    } catch {
      toast.error("Erro ao salvar configuração.");
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async () => {
    setLoading(true);
    try {
      await api.post("/payment-settings", { provider: "infinitypay", token: handle.trim(), active: false });
      toast.success("InfinityPay desativado.");
      if (onSave) onSave();
      onClose();
    } catch {
      toast.error("Erro ao desativar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className={classes.dialogTitle}>InfinityPay — Configurar Integração</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Informe sua <strong>InfiniteTag</strong> (nome de usuário no app InfinityPay, sem o $ inicial).<br />
            Com isso o sistema consegue gerar links de pagamento via cartão e PIX automaticamente.
          </Typography>
        </Box>

        <TextField
          label="InfiniteTag (handle)"
          value={handle}
          onChange={(e) => setHandle(e.target.value)}
          fullWidth margin="dense" variant="outlined"
          placeholder="ex: minhaempresa"
          helperText="Encontre em: App InfinityPay → Perfil → InfiniteTag"
        />

        <FormControlLabel
          control={<Switch checked={active} onChange={(e) => setActive(e.target.checked)} color="primary" />}
          label="Integração ativa"
          style={{ marginTop: 12 }}
        />

        <Box style={{ marginTop: 16, padding: 12, background: "#f5f3ff", borderRadius: 8, border: "1px solid #ddd6fe" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#4c1d95" }}>
            💡 O webhook de confirmação de pagamento será configurado automaticamente em:<br />
            <strong>{window.location.origin}/webhook/payments/infinitypay</strong>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        {handle && <Button onClick={handleRemove} color="secondary" disabled={loading}>Desativar</Button>}
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={loading}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfinityPayModal;
